const postHogFeatureFlagKeys = {
  // Without speech capabilities (TTS/STT)
  kem2_0Pilot_v1: "kem-2-0-pilot-v1",
  DISABLE_CHATS_AND_FORUMS: "disable-chats-and-forums",
  CORSANO_METRICS: "corsano-metrics",
  OTP_ISSUE_WARNING: "otp-issue-warning",
} as const;

export default postHogFeatureFlagKeys;
